import '@/global-extensions'
import { EvmErrorPage } from '@evm-ui/pages/EvmErrorPage'
import { createRoute, createRouter } from '@tanstack/react-router'
import { Loading } from '@ui/components/Loading'
import { Duration } from '@ui/features/themes/design/0_primitives'
import { t } from '@ui/lib/i18n'
import { analyticsRoutes } from './analytics.routes'
import { bridgeRoutes } from './bridge.routes'
import { crvusdRoutes } from './crvusd.routes'
import { daoRoutes } from './dao.routes'
import { dexRoutes } from './dex.routes'
import { lendRoutes } from './lend.routes'
import { llamalendRoutes } from './llamalend.routes'
import { rootRoute } from './root.routes'

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: Loading, // Redirect is handled by the `useOnChainUnavailable` hook
  head: () => ({ meta: [{ title: 'Curve.finance' }] }),
})

export const router = createRouter({
  scrollRestoration: true,
  scrollRestorationBehavior: 'instant',
  defaultPendingComponent: Loading,
  defaultPendingMs: Duration.Transition,
  routeTree: rootRoute.addChildren([
    indexRoute,
    analyticsRoutes,
    crvusdRoutes,
    daoRoutes,
    dexRoutes,
    lendRoutes,
    llamalendRoutes,
    bridgeRoutes,
  ]),
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  defaultErrorComponent: ({ error }) => (
    <>
      <head>
        <title>{t`Error` + ' - Curve'}</title>
      </head>
      <EvmErrorPage
        title={t`Unexpected Error`}
        subtitle={(error as Error).message || t`An unexpected error occurred`}
        error={error}
      />
    </>
  ),
  defaultNotFoundComponent: () => (
    <>
      <head>
        <title>{t`Error 404` + ' - Curve'}</title>
      </head>
      <EvmErrorPage title="404" subtitle={t`Page Not Found`} continueUrl="/" />
    </>
  ),
})

// Register router for type safety
declare module '@tanstack/react-router' {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Register {
    router: typeof router
  }
}
